import React from 'react';
import Delegation from '../components/Delegation';

const DelegationPage = () => {
  return <Delegation />;
};

export default DelegationPage;
